<template>
    <v-flex v-if="coverageIteration.config?.enable_science_files && finishedSimulation" xs12 style="position:relative;" >
      <v-card class="maincontent" >
        <v-card-title style="flex-direction:column;align-items:stretch;height:100%;" >            
            <template>
              <v-layout row wrap mt-2 style="flex:0 0 auto;" >
                <v-flex class="centercontent" xs6 pr-2><span class="body-2">{{$t('Pilot.FileTransfert.Cycle')}}</span></v-flex>
                <!-- <v-flex class="centercontent" xs4 pl-2 pr-2 ><span class="body-2">{{$t('Pilot.FileTransfert.NavFieldName')}}</span><v-btn small icon @click="downloadFile(`/api/gliderfilevirtual/download/gli/${infosSimMission.id}/all`)" ><v-icon>mdi-download</v-icon></v-btn></v-flex> -->
                <v-flex class="centercontent" xs6 pl-2 ><span class="body-2">{{$t('Pilot.FileTransfert.PldFieldName')}}</span><v-btn small icon @click="downloadFile(`/api/gliderfilevirtualcov/download/pld1/${coverageIteration.id}/${glider}/all`)"><v-icon>mdi-download</v-icon></v-btn></v-flex>
              </v-layout>            
              <v-layout row wrap style="flex:1 0;overflow:auto;align-content:flex-start;">
                <template v-for="yo in mission.yoArray">
                  <v-flex class="centercontent" :key="`cycle_${yo.yosCycle}`" xs6 pr-2>{{yo.yosCycle}}</v-flex>                  
                  <v-flex class="centercontent" :key="`pld_${yo.yosCycle}`" xs6 pl-2 >
                    <v-btn small icon  @click="downloadFile(`/api/gliderfilevirtualcov/download/pld1/${coverageIteration.id}/${glider}/${yo.yosCycle}`)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>                    
                  </v-flex>                              
                </template>
              </v-layout> 
            </template>            
        </v-card-title>
      </v-card>      
    </v-flex>
    <div v-else ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">      
      <span class="title" style="margin:auto">{{finishedSimulation?$t('Pilot.FileTransfert.NotActivated'):$t('Pilot.FileTransfert.NoDataAvailable')}}</span> 
    </div>    
</template>
<script setup lang="ts">    
  import { CoverageState } from '@/enum/CoverageState';
import { CoverageStep } from '@/enum/CoverageStep';
import { AloMission } from  '@/models/alo/AloMission'     
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
  import apiHelpers from '@/utils/api'
import { computed } from 'vue';

  const props = defineProps<{coverageIteration:AloDbCoverageIteration,mission:AloMission,glider:string,uiid:string}>()
  function downloadFile(url:string){
      apiHelpers.downloadFile(url,'.csv')
  }

  const finishedSimulation = computed( () => {
    return (props.coverageIteration.COV_PROCESSING_STATE == CoverageState.finished || props.coverageIteration.COV_PROCESSING_STATE == CoverageState.aborted) && props.coverageIteration.COV_PROCESSING_STEP == CoverageStep.FinalSimulation
  })
  
</script>